/**
 * VenueSection Component
 * 
 * Reusable venue information display component.
 * Shows venue name and address details with optional icon.
 * 
 * Props:
 * - title: Section title (default: "Wedding Venue")
 * - showIcon: Whether to show location icon (default: false)
 * - className: Additional CSS classes
 */

import React from 'react';
import { VENUE_INFO } from '../../data/eventsData';

const VenueSection = ({ 
  title = "The Venue", 
  showIcon = false,
  className = ""
}) => {
  return (
    <div className={`location-section ${className}`}>
      <div className="location-container">
        <div className="location-title">
          {showIcon && <img src="/location.png" alt="Location" className="location-icon" />}
          <h2>{title}</h2>
        </div>
        <div className="location-details">
          <h3>{VENUE_INFO.name}</h3>
          <div className={showIcon ? "location-address" : "address"}>
            {VENUE_INFO.address.map((line, index) => (
              <p key={index}>{line}</p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VenueSection;